<template>
	<PageTitleComponent />

	<div class="form-container">
		<form
			action="#"
			@submit="null"
		>
			<h2>Set Your Password</h2>

			<LoadingComponent
				:loading="true"
				v-if="loading"
			/>
			<div v-else-if="success === false">
				<div class="error">
					<p>There was an error processing your request.</p>
					<p>Create a new link by entering your email address <router-link :to="{ name: 'forgot-password' }">here</router-link>.</p>
					<p>Please <a href="mailto:info@realschools.com.au">contact support</a> if the issue persists.</p>
				</div>
			</div>
			<div v-else>
				<p>If your email address exists, a password reset email has been sent to your email address:</p>
				<div class="email">
					<p>
						<strong>{{ email }}</strong>
					</p>
				</div>
				<p>Please check your inbox and follow the instructions.</p>
			</div>
		</form>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageTitleComponent from '@/components/shared/PageTitleComponent.vue';
import { useUser } from '@/stores/userStore';
import { mapActions } from 'pinia';
import LoadingComponent from '@/components/shared/LoadingComponent.vue';

export default defineComponent({
	components: { PageTitleComponent, LoadingComponent },
	data() {
		return {
			email: '',
			success: null as boolean | null,
			loading: true,
		};
	},
	computed: {
		isFormValid(): boolean {
			return this.email.length > 0;
		},
	},
	async beforeMount() {
		const email = this.$route.query.email as string;
		if (!email) {
			this.$router.push({ name: 'forgot-password' });
			return;
		}

		this.email = email;

		const res = await this.requestPasswordReset(this.email, true);
		this.success = res.success;
		this.loading = false;
	},
	methods: {
		...mapActions(useUser, ['requestPasswordReset']),
	},
});
</script>

<style scoped lang="scss">
.form-container {
	display: flex;
	flex: 1;
	justify-content: center;
	align-items: center;
	margin-bottom: 100px;
}

form {
	position: relative;
	background-color: rgb(var(--rs-color-brand-navy));
	padding: var(--rs-layout-content-padding);
	width: clamp(200px, 400px, 100%);
	min-height: 300px;

	h2 {
		margin-bottom: 40px;
		color: white;
		font-size: 24px;
	}

	p {
		color: white;
		font-size: 14px;
	}

	.error {
		color: #ff6b6b;

		a {
			color: white;
		}
	}
}
</style>
